import { implementCustomExpressions } from '../__generated/implementation.js';
import { CornerCountersinkHoles, CountersinkHole, KickPlateCountersinkHoles } from '../__generated/model/index.js';
import { createCountersinkHolePolygon } from '../polygons/countersink-hole.js';
import { createMultipleHolePolygons } from '../polygons/multple-fixing-holes.js';
const sizeTolerance = {
    x: 0,
    y: 0
};
export const anyCountersinkHoleExpressions = implementCustomExpressions({
    AnyCountersinkHole: {
        $sizeX: (self)=>2 * self.topRadius,
        $sizeY: (self)=>2 * self.topRadius,
        $innerSize: (self)=>2 * self.bottomRadius,
        $sizeTolerance: ()=>sizeTolerance,
        $polygons: (self)=>{
            if (CornerCountersinkHoles.is(self)) {
                return createMultipleHolePolygons(self, self.$plate, {
                    horizontal: 4
                });
            } else if (KickPlateCountersinkHoles.is(self)) {
                return createMultipleHolePolygons(self, self.$plate, {
                    horizontal: self.$horizontalCount,
                    vertical: self.$verticalCount
                });
            } else if (CountersinkHole.is(self)) {
                return [
                    createCountersinkHolePolygon(self)
                ];
            }
            return [];
        }
    }
});

//# sourceMappingURL=any-countersink-hole.js.map